import type { SVGProps } from 'react'

export const ShoppingCartFilledIcon = ({
  ...props
}: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="currentColor"
      {...props}
    >
      <path d="M280-76.41q-33 0-56.5-23.5t-23.5-56.5q0-33 23.5-56.5t56.5-23.5q33 0 56.5 23.5t23.5 56.5q0 33-23.5 56.5T280-76.41Zm400 0q-33 0-56.5-23.5t-23.5-56.5q0-33 23.5-56.5t56.5-23.5q33 0 56.5 23.5t23.5 56.5q0 33-23.5 56.5T680-76.41ZM210.15-803.59h580.92q27.21 0 41.41 24.09 14.19 24.09 1.04 48.91l-136.5 246.68q-11.48 20.71-30.8 32.31-19.33 11.6-42.31 11.6H328.07l-41.85 76.41h477.37v87.18H280q-47.63 0-71.59-41.42-23.95-41.41-1.76-82.08L259.93-496 117.85-796.41H36.41v-87.18h135.74l38 80Z" />
    </svg>
  )
}
